// Partial — vitrine de evidências da moeda por usuário (0088).
// Rota sem link de navegação, fora do `RequireAuth`: é página de revisão
// visual, não tela de produto.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { CURRENCY_SHOWCASE_PATH } from "./static-showcase-path";

const CurrencyShowcasePage = lazyWithRetry(
  () => import("./CurrencyShowcasePage"),
);

const routes: RouteObject[] = [
  { path: CURRENCY_SHOWCASE_PATH, Component: CurrencyShowcasePage },
];

export default routes;
